import { historyImplementation } from '@shared/infrastructure/router/historyImplementation';

export const historyRepository = {
  browserRouter: historyImplementation.browserRouter,
  push: historyImplementation.push,
  back: historyImplementation.back
};
